import React from "react";
import styles from "./SecondaryTabs.module.scss";

const SecondaryTabs = ({
  tabs = [],
  activeId,
  onSelect,
  ariaLabel = "Sections",
}) => {
  const visibleTabs = tabs.filter((tab) => !tab.hidden);

  return (
    <div className={styles.wrapper}>
      <div className={styles.tabRow} role="tablist" aria-label={ariaLabel}>
        {visibleTabs.map((tab) => {
          const isActive = tab.id === activeId;

          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={isActive}
              className={
                isActive
                  ? `${styles.tabButton} ${styles.active}`
                  : styles.tabButton
              }
              onClick={() => onSelect(tab.id)}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SecondaryTabs;
